import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class AlertasService {

    constructor(
        public msj: MessageService
    ) { }

    info(texto) {
        this.msj.add({ key: 'tc', severity: 'info', summary: 'Aviso: ', detail: texto ,  life: 13000 });
    }

    alerta(texto) {
        this.msj.add({ key: 'tc', severity: 'warn', summary: 'Advertencia: ', detail: texto ,  life: 13000 });
    }

    error(texto) {
        this.msj.add({ key: 'tc', severity: 'error', summary: 'Error: ', detail: texto ,  life: 10000});
    }

    cierreSesion(texto) {
        this.msj.add({ key: 'tc', severity: 'warn', summary: 'Advertencia: ', detail: texto});
    }

    inactividad(texto, contador) {
        this.msj.add({ key: 'tc', severity: 'warn', summary: 'Advertencia: ', detail: texto, sticky: false, life: 1000 * contador,});
    }

    limpiar() {
        this.msj.clear();
    }

}
